module.exports = __webpack_public_path__ + "static/media/2.b1ca9c1c.JPG";